// 资源管理公共配置
export const resourceFormConfig = {
  // 基本信息表单
  getBasicInfo(onOpenMap) {
    return {
      title: '资源信息',
      type: 'cardForm',
      data: [
        {
          name: '资源名称',
          type: 'input',
          cols: 12,
          key: 'name',
          maxLength: 50,
          rules: [
            {
              required: true,
              type: 'string'
            }
          ]
        },
        {
          name: '资源类型',
          type: 'select',
          cols: 12,
          key: 'resourcesType',
          rules: [
            {
              required: true,
              type: 'string'
            }
          ]
        },
        {
          name: '占地面积 (m²)',
          type: 'inputNumber',
          cols: 12,
          key: 'siteArea',
          rules: [
            {
              required: true,
              type: 'number'
            }
          ]
        },
        {
          name: '用地性质',
          type: 'select',
          cols: 12,
          key: 'landUseNature',
          rules: [
            {
              required: true
            }
          ]
        },
        {
          name: '经纬度',
          type: 'row',
          cols: 12,
          rules: [
            {
              required: true
            }
          ],
          gutter: 5,
          children: [
            {
              type: 'input',
              cols: 21,
              key: 'dw',
              label: '经纬度',
              disabled: true,
              placeholder: '请定位所在位置',
              rules: [
                {
                  required: true,
                  type: 'string',
                  message: '请定位所在位置'
                }
              ]
            },
            {
              type: 'button',
              label: '定位',
              cols: 3,
              key: 'a1',
              props: {
                type: 'primary',
                icon: 'environment',
                on: {
                  click: onOpenMap
                }
              }
            }
          ]
        },
        {
          name: '地理位置',
          type: 'input',
          cols: 12,
          key: 'address',
          rules: [
            {
              required: true,
              type: 'string'
            }
          ],
          suffix: {
            type: 'button',
            text: '定位信息',
            onClick: 'openMap'
          }
        },
        {
          name: '行政区划',
          type: 'cascader',
          cols: 12,
          key: 'regionCode',
          rules: [
            {
              required: true,
              type: 'array'
            }
          ]
        },
        {
          name: '建筑面积 (m²)',
          type: 'inputNumber',
          cols: 12,
          key: 'floorArea',
          rules: [
            {
              required: true,
              type: 'number'
            }
          ]
        },
        {
          name: '联系人',
          type: 'input',
          cols: 12,
          key: 'contactName',
          rules: [
            {
              required: true,
              type: 'string'
            }
          ]
        },
        {
          name: '联系电话',
          type: 'input',
          cols: 12,
          key: 'contactPhone',
          rules: [
            {
              required: true,
              type: 'string'
            }
          ]
        },
        {
          name: '招募类型',
          type: 'select',
          cols: 12,
          key: 'recruitmentType',
          rules: [
            {
              required: true,
              type: 'string'
            }
          ]
        },
        {
          name: '资源简介',
          type: 'rich',
          cols: 24,
          key: 'content',
          rules: [
            {
              required: true,
              type: 'string'
            }
          ]
        },
        {
          name: 'VR地址',
          type: 'input',
          cols: 24,
          key: 'vrUrl',
          maxLength: 300,
          props: {
            maxLength: 1000
          }
        },
        {
          name: '是否重点资源',
          type: 'radio',
          cols: 24,
          key: 'isZdzy',
          typeData: [
            { name: '是', value: '1' },
            { name: '否', value: '0' }
          ],
          rules: [
            {
              required: true,
              type: 'string'
            }
          ]
        },
        {
          name: '排序',
          type: 'inputNumber',
          cols: 24,
          key: 'sort',
          rules: [
            {
              required: true,
              type: 'number'
            }
          ]
        },
        {
          name: '封面图',
          type: 'upload',
          cols: 24,
          key: 'imgUrl',
          maxLength: 1,
          rules: [
            {
              required: true,
              type: 'string'
            }
          ]
        }
      ]
    }
  },

  // 审核模式的表单配置（只读，带变更标记）
  getAuditFormData(changeLog) {
    const isChanged = field => {
      return changeLog.some(log => log.operationInfo.includes(field))
    }

    return [
      {
        title: '基本信息',
        type: 'cardForm',
        data: [
          {
            name: '资源名称',
            type: 'input',
            cols: 12,
            key: 'name',
            className: isChanged('name') ? 'changed' : ''
          },
          {
            name: '资源类型',
            type: 'input',
            cols: 12,
            key: 'resourcesTypeLabel',
            className: isChanged('resourcesType') ? 'changed' : ''
          },
          {
            name: '占地面积 (m²)',
            type: 'input',
            cols: 12,
            key: 'siteArea',
            className: isChanged('siteArea') ? 'changed' : ''
          },
          {
            name: '地理位置',
            type: 'input',
            cols: 12,
            key: 'address',
            className: isChanged('address') ? 'changed' : ''
          },
          {
            name: '行政区划',
            type: 'input',
            cols: 12,
            key: 'regionCode',
            className: isChanged('regionCode') ? 'changed' : ''
          },

          {
            name: '用地性质',
            type: 'input',
            cols: 12,
            key: 'landUseNatureLabel',
            className: isChanged('landUseNature') ? 'changed' : ''
          },
          {
            name: '建筑面积 (m²)',
            type: 'input',
            cols: 12,
            key: 'floorArea',
            className: isChanged('floorArea') ? 'changed' : ''
          },
          {
            name: '联系人',
            type: 'input',
            cols: 12,
            key: 'contactName'
          },
          {
            name: '联系电话',
            type: 'input',
            cols: 12,
            key: 'contactPhone'
          },
          {
            name: '招募类型',
            type: 'input',
            cols: 12,
            key: 'recruitmentTypeLabel',
            className: isChanged('recruitmentType') ? 'changed' : ''
          }
        ]
      },
      {
        title: '资源详情',
        type: 'cardForm',
        data: [
          {
            name: '资源简介',
            type: 'rich',
            cols: 12,
            key: 'content',
            className: isChanged('content') ? 'changed' : ''
          },
          {
            name: 'VR地址',
            type: 'input',
            cols: 12,
            key: 'vrUrl',
            className: isChanged('vrUrl') ? 'changed' : ''
          },
          {
            name: '视频',
            type: 'upload',
            cols: 12,
            key: 'videoUrl',
            className: isChanged('videoUrl') ? 'changed' : ''
          }
        ]
      },
      {
        title: '其他信息',
        type: 'cardForm',
        data: [
          {
            name: '是否重点资源',
            type: 'input',
            cols: 12,
            key: 'isZdzy',
            customRender: value => (value == '1' ? '是' : '否'),
            className: isChanged('isZdzy') ? 'changed' : ''
          },
          {
            name: '排序',
            type: 'input',
            cols: 12,
            key: 'sort',
            className: isChanged('sort') ? 'changed' : ''
          },
          {
            name: '封面图',
            type: 'upload',
            cols: 12,
            key: 'imgUrl',
            className: isChanged('imgUrl') ? 'changed' : ''
          },
          {
            name: '上报人',
            type: 'input',
            cols: 12,
            key: 'createByName'
          },
          {
            name: '上报时间',
            type: 'input',
            cols: 12,
            key: 'createTime'
          }
        ]
      }
    ]
  }
}
